<template>
    <div class="container-fluid" style="height: 100vh; background-color: #fff">
        <div class="row h-100 justify-content-center align-items-center">
            <div v-if="isIntoIframe" class="col text-center">
              <div class="circle-loader">
                <svg
                    version="1.1"
                    class="svg-loader"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 80 80"
                    enable-background="new 0 0 80 80"
                    xml:space="preserve"
                >
                  <text x="15" y="42" class="small font-weight-bold" v-text="_trans('Loading..')"></text>
                  <path d="M1.625,41.312c0-21.919,17.769-39.688,39.688-39.688c13.07,0,24.662,6.32,31.893,16.068C66.022,7.021,53.832,0,40,0C17.909,0,0,17.909,0,40c0,13.832,7.021,26.022,17.693,33.206C7.945,65.974,1.625,54.383,1.625,41.312z">
                  <animateTransform
                      attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 40 40"
                      to="360 40 40"
                      dur="0.6s"
                      repeatCount="indefinite"
                  >
                  </animateTransform>
                </path>
              </svg>
              </div>
              <!--<img :src="logo" alt="" class="img-fluid" style="max-width: 300px" />-->
            </div>
        </div>
    </div>
</template>

<script>
    // import logo from "@assets/stiemert/img/logo-home.gif";

    import CircleLoader from "@configurator/comp/circleLoader.vue";

    export default {
        name: "IntoIframe",
      components: {CircleLoader},
        data: function () {
            return {
                // logo: logo
            };
        }
    };
</script>

<style lang="scss" scoped>
.circle-loader {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 80px;

  .svg-loader {
    path {
      fill: $primary !important;
    }
  }
  text.small.font-weight-bold {
    color: #1a1a1a !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/custom/stiemert/pages/intoIframe.vue